import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ListContextInner, DEFAULT_LIST_CONTEXT } from './list-context-inner.js';

var ListContext = function ListContext(_ref) {
  var size = _ref.size,
      theme = _ref.theme,
      mode = _ref.mode,
      disabled = _ref.disabled,
      iconPlacement = _ref.iconPlacement,
      itemTag = _ref.itemTag,
      children = _ref.children,
      _ref$onItemClick = _ref.onItemClick,
      onItemClick = _ref$onItemClick === void 0 ? function () {} : _ref$onItemClick;
  var contextValue = useMemo(function () {
    return {
      iconPlacement: iconPlacement,
      disabled: disabled,
      size: size,
      mode: mode,
      theme: theme,
      itemTag: itemTag,
      onItemClick: onItemClick
    };
  }, [iconPlacement, disabled, size, mode, theme, itemTag, onItemClick]);
  return React.createElement(ListContextInner.Provider, {
    value: contextValue
  }, children);
};
ListContext.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  mode: PropTypes.oneOf(['nude', 'cell']),
  theme: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  itemTag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  onItemClick: PropTypes.func
};
ListContext.defaultProps = DEFAULT_LIST_CONTEXT;

export { ListContext };
